module.exports = {"540423100":"墨脱镇","540423200":"加热萨乡","540423201":"甘登乡","540423202":"达木珞巴民族乡","540423203":"帮辛乡","540423204":"格当乡","540423205":"德兴乡","540423206":"背崩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540423.json
// module id = 2719
// module chunks = 0